import { render, staticRenderFns } from "./examination.vue?vue&type=template&id=4121603e&scoped=true&"
import script from "./examination.vue?vue&type=script&lang=js&"
export * from "./examination.vue?vue&type=script&lang=js&"
import style0 from "./examination.vue?vue&type=style&index=0&id=4121603e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4121603e",
  null
  
)

export default component.exports